export default "__VITE_ASSET__Cck0P8QK__"